{"RZVjfY":[{"type":0,"value":"Sie erhalten innerhalb von ein Tag eine Antwort."}],"aXLE6j":[{"type":0,"value":"Mein "},{"type":1,"value":"island"}]}